// extracted by mini-css-extract-plugin
export var filtersTaxo = "listResults-module--filters-taxo--f3131";
export var listResult = "listResults-module--list-result--b5489";
export var resultContent = "listResults-module--result-content--20e4b";
export var resultItem = "listResults-module--result-item--38822";
export var resultMore = "listResults-module--result-more--732c3";
export var resultResume = "listResults-module--result-resume--8995a";
export var resultTitle = "listResults-module--result-title--b02f1";
export var resultType = "listResults-module--result-type--15a59";
export var resultTypeIcon = "listResults-module--result-type-icon--93fb4";
export var resultTypeType = "listResults-module--result-type-type--f6468";
export var results = "listResults-module--results--f7009";
export var resultsContainer = "listResults-module--results-container--05b3c";
export var resultsTop = "listResults-module--results-top--75813";